import { Tramitacao } from "@/models/processo-eletronico/tramitacao";
import { TramitacaoAPI } from "@/api/processo-eletronico/tramitacao.api";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";import { Viproc } from "@/models/viproc";

const tramitacaoApi = new TramitacaoAPI();

const findByProcessoId = (
  processoId: number,
  page?: number,
  size?: number
): AxiosObservable<Tramitacao> => {
  return tramitacaoApi.findByProcessoId(processoId, page, size);
};

export default { findByProcessoId };
